import axios from "../../utils/axios";
export const fetchJobs = async (filter) => {
    if (filter) {

        const response = await axios.get(`/jobs?type_like=${filter}`);

        return response.data
    }
    const response = await axios.get(`/jobs`);

    return response.data
}
export const fetchAddJob = async ({ data, }) => {
    const response = await axios.post(`/jobs`, data);
    return response.data
}

export const fetchDeleteJob = async (id) => {
    const response = await axios.delete(`/jobs/${id}`);
    return response.data
}